<script>
import Chart from 'chart.js';

export default {
  name: 'AdminActivityChart',
  props: {
    colors: Array,
    data: Array,
    loading: Boolean
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      if (this.data) {
        const data = {
          labels: this.data.map(row => this.$d(this.convertDate(row.day), 'short')),
          datasets: [
            {
              label: 'Pages Published',
              data: this.data.map(row => row.total),
              backgroundColor: 'transparent',
              borderColor: this.colors[0],
              pointBackgroundColor: 'white',
              borderWidth: 2
            }
          ]
        };

        return data;
      }
    },

    total() {
      if (this.data && this.data.length) {
        return this.data.map(row => row.total).reduce((accum, val) => accum + val);
      } else {
        return 0;
      }
    }
  },
  watch: {
    data() {
      this.updateChart();
    }
  },
  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'line',
      options: {
        animation: false,
        title: {
          display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        elements: {
          point: {
            radius: 4,
            hoverRadius: 5
          }
        },
        legend: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                callback: value => {
                  if (value % 1 === 0) {
                    // only integers
                    return value.toLocaleString('en-US');
                  }
                }
              }
            }
          ]
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem.datasetIndex].label;
              const value = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toLocaleString(
                'en-US'
              );
              return `${label} (${value})`;
            }
          }
        }
      }
    });
    this.updateChart();
  },
  methods: {
    // Converts a date like 2018-08-22 to a date object
    convertDate(string) {
      const year = string.slice(0, 4);
      const month = parseInt(string.slice(5, 7)) - 1;
      const day = string.slice(8, 10);
      return new Date(year, month, day);
    },

    // Updates and renders the chart
    updateChart() {
      if (this.chartData) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  }
};
</script>

<template>
  <div class="chart-container">
    <h2 class="chart-title">
      {{ $n(total, 'integer') }}
      <small class="chart-subtitle">Pages Published</small>
    </h2>
    <div ref="chartContainer" v-loading="loading" class="chart">
      <canvas ref="chart" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.chart-title {
  font-size: 2rem;
  text-align: center;
}

.chart-subtitle {
  display: block;
  font-size: $--font-size-small;
  color: $--color-gray-40;
}

.chart {
  position: relative;
  height: 12rem;
  margin-bottom: 2rem;

  @include breakpoint('sm-and-down') {
    height: 8rem;
  }
}
</style>
